import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";

interface Props {
  data: {
    date: string;
    revenue: number;
    expenses: number;
  }[];
}

export default function RevenueExpenseChart({ data }: Props) {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />

        <Line
          type="monotone"
          dataKey="revenue"
          stroke="#2e7d32"
          strokeWidth={2}
          name="Revenue"
        />

        <Line
          type="monotone"
          dataKey="expenses"
          stroke="#d32f2f"
          strokeWidth={2}
          name="Expenses"
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
